import {
  FETCH_DEPOSIT_APPROVAL_REQUEST,
  FETCH_DEPOSIT_APPROVAL_SUCCESS,
  FETCH_DEPOSIT_APPROVAL_ERROR,
  UPDATE_DEPOSIT_APPROVAL_REQUEST,
  UPDATE_DEPOSIT_APPROVAL_SUCCESS,
  UPDATE_DEPOSIT_APPROVAL_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  error: null,
  isFetching: false,
  list: [],
  updating: {},
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_DEPOSIT_APPROVAL_REQUEST:
      return {
        ...state,
        error: null,
        isFetching: true,
      }

    case FETCH_DEPOSIT_APPROVAL_SUCCESS:
      return {
        ...state,
        error: null,
        isFetching: false,
        list: action.payload,
      }

    case FETCH_DEPOSIT_APPROVAL_ERROR:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      }

    case UPDATE_DEPOSIT_APPROVAL_REQUEST:
      return {
        ...state,
        updating: {
          ...state.updating,
          [action.payload.idWarehouseApproval]: true,
        },
      }

    case UPDATE_DEPOSIT_APPROVAL_SUCCESS:
      return {
        ...state,
        updating: {
          ...state.updating,
          [action.payload.idWarehouseApproval]: false,
        },
        // Update the item in the list optimistically
        list: state.list && state.list.content ? {
          ...state.list,
          content: state.list.content.map(item =>
            item.idWarehouseApproval === action.payload.idWarehouseApproval
              ? { ...item, requiresApproval: action.payload.requiresApproval }
              : item
          )
        } : state.list
      }

    case UPDATE_DEPOSIT_APPROVAL_ERROR:
      return {
        ...state,
        updating: {
          ...state.updating,
          [action.payload.idWarehouseApproval]: false,
        },
      }

    default:
      return state
  }
}